module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAUVBMVEXu8vnr7/fu8vkAAADu8vru8vju8vkzMzNhY2SQkpbX2uA+Pz+cnqLj5u3LztR5en1KS0w+P0CFh4lWV1i/wsioqq9KS0u0trttb3BtbnBVV1jtPktVAAAABnRSTlPvILAAv8CtPr+fAAAA9UlEQVRIx+3W7aqDMAwG4FZ3mjT9VM92Pu7/QhcdFDacWwKDDXz/JC0+WBFrTW8PxknT2d5YZvIw65wqvExdjBa6He7wKhkHWAvSNiRm6wl5EyLcDW7Cm2u996HdUgA9z/y2kRAetdBNWkh/Osj5jlUFOaiASQYxEpUFYskCGOfeM1zMMA2PYXMNCt5jmbtEcpi5ibw6KQxcCUAOK1evhRHm/HD3L3jG5Fw6cT0tMwIYuaGCI3E9SmBNbZyqBEJp4wIiCJUu39MEz8K2NeHoR4SrvGZ7zOGeC7QJHeE6w/x2f6sdfig0WnjQuU5/mO9tJ2dftj8DIEBOCNbdPH4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/tiktok.png
// module id = LouY
// module chunks = 44